import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { ProjectListViewModel } from '../../viewModels/ProjectListViewModel';
import { Project } from '../../shared/models/Project';
import { TopBar } from 'components/TopBar/TopBar';
import { ProjectList } from 'components/ProjectList/ProjectList';
import { OrganizationHeader } from '../../components/OrganizationHeader/OrganizationHeader';
import { BannerCarousel } from '../../components/BannerCarousel/BannerCarousel';
import { ViewMoreButton } from '../../components/ViewMoreButton/ViewMoreButton';
import { useOrganization } from '../../contexts/OrganizationContext';
import './ProjectListView.css';

interface ProjectListViewProps {
  viewModel: ProjectListViewModel;
  onProjectClick?: (project: Project) => void;
}

/**
 * 项目列表视图（H5 用户端）
 */
export const ProjectListView: React.FC<ProjectListViewProps> = observer(({ viewModel, onProjectClick }) => {
  const { organization } = useOrganization();

  useEffect(() => {
    if (!viewModel.initialized && organization) {
      viewModel.loadProjects({ organizationId: organization.id, organizationType: organization.type });
    }
    if (viewModel.banners.length === 0 && !viewModel.bannerLoading && organization) {
      viewModel.loadBanners(organization.id);
    }
  }, [viewModel, organization]);

  return (
    <div className="project-list-view">
      <TopBar
        title="项目列表"
        showBack
        onBack={() => window.history.back()}
      />

      {/* 机构信息 */}
      <OrganizationHeader />

      {/* Banner 轮播图 */}
      <BannerCarousel
        banners={viewModel.banners}
        loading={viewModel.bannerLoading}
      />

      {viewModel.error && (
        <div className="error-message">
          {viewModel.error}
          <button onClick={() => viewModel.refresh()}>重试</button>
        </div>
      )}

      <ProjectList
        projects={viewModel.projects}
        loading={viewModel.loading}
        emptyText="暂无项目"
        onItemClick={onProjectClick}
      />

      {viewModel.hasMore && !viewModel.loading && (
        <ViewMoreButton
          text="加载更多"
          onClick={() => viewModel.loadMore()}
        />
      )}

      {!viewModel.hasMore && viewModel.projects.length > 0 && (
        <div className="no-more">
          <p>没有更多了</p>
        </div>
      )}
    </div>
  );
});

